import React from 'react';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import { paths } from '@/app/paths';
import { BrokerGroupsListPage } from './BrokerGroupsListPage';

export const brokerGroupsRoutes = [
	{
		path: 'broker-groups',
		element: <BrokerGroupsListPage />,
		handle: { title: 'Broker groups', icon: <BusinessOutlinedIcon /> },
		// Renders nothing: the list page always renders BrokerGroupDrawer and opens it on this
		// route, so the drawer can slide in and out (null, not left out, so the router doesn't
		// warn)
		children: [{ path: ':brokerGroupId', element: null }],
	},
];

export const brokerGroupsNavItem = {
	text: 'Broker groups',
	icon: <BusinessOutlinedIcon sx={{ fontSize: 30 }} />,
	link: `${paths.admin}/broker-groups`,
};
